import React from "react";
import { FiArrowUpRight } from "react-icons/fi";

const TileShell = ({
  icon: Icon,
  title,
  actionLabel = "Open",
  onAction,
  className = "",
  bodyClassName = "",
  children,
}) => (
  <section
    className={`flex min-w-0 flex-col rounded-2xl border border-gray-200 bg-white p-5 shadow-sm transition hover:shadow-md ${className}`}
  >
    <header className="mb-4 flex items-center gap-2.5">
      {Icon && (
        <span className="grid h-8 w-8 flex-none place-items-center rounded-xl bg-blue-50 text-blue-600">
          <Icon size={16} />
        </span>
      )}
      <h2 className="min-w-0 flex-1 truncate text-[0.95rem] font-bold tracking-tight text-gray-800">
        {title}
      </h2>
      {onAction && (
        <button
          type="button"
          onClick={onAction}
          className="inline-flex flex-none items-center gap-1 rounded-lg px-2 py-1 text-xs font-semibold text-blue-600 transition hover:bg-blue-50"
        >
          {actionLabel}
          <FiArrowUpRight size={13} />
        </button>
      )}
    </header>
    <div className={`min-w-0 flex-1 ${bodyClassName}`}>{children}</div>
  </section>
);

export default TileShell;
